import React from 'react';

export const navbar_finite_state = {
  CLOSE: 'CLOSE',
  CONTACT: 'CONTACT',
  INITIAL: 'INITIAL',
  LOGIN: 'LOGIN',
  SEARCH: 'SEARCH',
  WAYS_TO_WORK: 'WAYS_TO_WORK',
};

const { Provider, Consumer } = React.createContext({
  clickedItem: navbar_finite_state.INITIAL,
  openModal() {},
  closeModal() {},
});

class NavProvider extends React.Component {
  state = {
    clickedItem: navbar_finite_state.INITIAL,
    isModalOpen: false,
  };

  openModal = event => {
    const { dataset: { id } = {} } = event.target;
    this.setState({
      isModalOpen: true,
      clickedItem: navbar_finite_state[id],
    });
  };

  closeModal = () =>
    this.setState({
      isModalOpen: false,
      clickedItem: navbar_finite_state.INITIAL,
    });

  render() {
    return (
      <Provider
        value={{
          clickedItem: this.state.clickedItem,
          isModalOpen: this.state.isModalOpen,
          openModal: this.openModal,
          closeModal: this.closeModal,
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { NavProvider, Consumer as NavConsumer };
